/**
 * Shared helper: locks a cell's width in pixels (header or body)
 * when the user has dragged the ResizeHandle. Without an override (px undefined or 0), it returns
 * empty styles — the cell falls back to the <table>'s natural sizing.
 *
 * Paired with `useColumnWidths` (`src/customHooks/useColumnWidths.ts`) and
 * `ResizeHandle` (`src/components/Table/ResizeHandle.tsx`).
 *
 * Usage:
 *   const { widths, setWidth, resetWidth } = useColumnWidths("myPageColumnWidths.v1");
 *   <TableCell sx={{ position: "relative", ...widthLockSx(widths["colKey"]) }}>
 *     Header
 *     <ResizeHandle onResize={(px) => setWidth("colKey", px)} onReset={() => resetWidth("colKey")} />
 *   </TableCell>
 */
export const widthLockSx = (px: number | undefined) =>
  typeof px === "number" && px > 0
    ? {
        width: `${px}px`,
        minWidth: `${px}px`,
        maxWidth: `${px}px`,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }
    : {};
